// Carousel photo HP (sections/cta-final.liquid) — controle tactile.
// Voir assets/base.css (.photo-carousel__track / @keyframes hp-carousel-
// scroll) pour le defilement automatique de base : une pure animation CSS
// en boucle, inchangee ici.
//
// Brief 2026-09-16 : le defilement automatique continue de tourner seul
// par defaut, mais au contact tactile c'est le doigt qui prend ENTIEREMENT
// le controle (glissement 1:1, y compris en arriere pour revoir une photo
// deja passee ; si le doigt ne bouge pas, le carousel ne bouge pas) — puis
// reprend l'automatique exactement la ou le doigt l'a laisse des le
// relachement, jamais un saut ni un retour a la position de depart.
// Uniquement des ecouteurs touch* (souris/desktop non concernes — la
// pause au survol existante, .photo-carousel:hover dans base.css, reste
// inchangee et independante de ce fichier).
(function () {
  var carousels = document.querySelectorAll('.photo-carousel');
  if (!carousels.length) return;

  carousels.forEach(function (carousel) {
    var track = carousel.querySelector('.photo-carousel__track');
    if (!track) return;

    var dragging = null; // null hors interaction ; objet d'etat pendant un geste
    var horizontalLock = null; // determine une seule fois par geste (null avant)

    function currentTranslateX() {
      var m = getComputedStyle(track).transform;
      if (!m || m === 'none') return 0;
      var match = m.match(/^matrix\(([^)]+)\)$/);
      if (!match) return 0;
      var parts = match[1].split(',');
      return parseFloat(parts[4]) || 0;
    }

    function halfWidth() {
      // Le track contient 2 jeux identiques (voir sections/cta-final.liquid,
      // aria-hidden sur le 2e) — sa largeur totale (width:max-content) vaut
      // donc 2x la largeur d'un jeu, exactement la distance d'une boucle
      // complete de l'animation (translateX(-50%)).
      return track.scrollWidth / 2;
    }

    function wrap(tx, half) {
      if (!half) return tx;
      while (tx > 0) tx -= half;
      while (tx < -half) tx += half;
      return tx;
    }

    function carouselDuration() {
      var raw = getComputedStyle(carousel).getPropertyValue('--carousel-duration');
      return parseFloat(raw) || 40;
    }

    function onTouchStart(evt) {
      if (evt.touches.length !== 1) return;
      var touch = evt.touches[0];
      dragging = {
        startX: touch.clientX,
        startY: touch.clientY,
        baseTx: currentTranslateX(),
        half: halfWidth()
      };
      horizontalLock = null;
      // Fige l'automatique exactement a sa position actuelle (meme valeur
      // en inline avant de retirer l'animation) : sans ce style
      // intermediaire identique, lui retirer le controle ferait sauter le
      // carousel a sa position de repos (transform:none).
      track.style.transform = 'translateX(' + dragging.baseTx + 'px)';
      track.style.animation = 'none';
    }

    function onTouchMove(evt) {
      if (!dragging || evt.touches.length !== 1) return;
      var touch = evt.touches[0];
      var deltaX = touch.clientX - dragging.startX;
      var deltaY = touch.clientY - dragging.startY;

      if (horizontalLock === null) {
        // Sens du geste tranche une seule fois, des qu'il devient net
        // (evite de decider sur un tremblement de 1-2px). Un geste surtout
        // vertical rend la main au scroll de page normal.
        if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;
        horizontalLock = Math.abs(deltaX) > Math.abs(deltaY);
        if (!horizontalLock) {
          resumeAuto();
          dragging = null;
          return;
        }
      }

      if (!horizontalLock) return;
      evt.preventDefault(); // uniquement une fois le geste confirme horizontal
      var tx = wrap(dragging.baseTx + deltaX, dragging.half);
      track.style.transform = 'translateX(' + tx + 'px)';
    }

    function resumeAuto() {
      var half = halfWidth();
      var tx = wrap(currentTranslateX(), half);
      var duration = carouselDuration();
      var fraction = half ? Math.abs(tx) / half : 0;
      track.style.transform = '';
      track.style.animation = '';
      // Delai negatif = reprend l'animation deja avancee de cette fraction,
      // sans saut visuel (technique standard pour "reprendre" une boucle
      // CSS a une position donnee).
      track.style.animationDelay = (-fraction * duration) + 's';
    }

    function onTouchEnd() {
      if (!dragging) return;
      // Toujours reprendre ici, y compris si horizontalLock est reste a
      // null (appui sans aucun mouvement — "exemple 2" du brief : le
      // carousel ne bouge pas tant que le doigt ne bouge pas, mais doit
      // bien reprendre l'automatique au relachement). Le seul cas ou il
      // ne faut PAS reprendre ici est le geste vertical (horizontalLock
      // === false) : resumeAuto() a deja ete appele dans onTouchMove, qui
      // a aussi remis dragging a null — ce onTouchEnd est alors court-
      // circuite par le garde-fou juste au-dessus.
      resumeAuto();
      dragging = null;
      horizontalLock = null;
    }

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: false });
    track.addEventListener('touchend', onTouchEnd, { passive: true });
    track.addEventListener('touchcancel', onTouchEnd, { passive: true });
  });
})();
